<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <confirm-box ref="confirm"></confirm-box>
        
        <div class="mb-4">
            <div v-if="!isEditName">
                <div class="d-flex">
                    <h1 class="h1">{{ name }}</h1>
                    <div class="d-flex align-items-center">
                        <button class="btn btn-small text-secondary" data-bs-toggle="dropdown">
                            <i class="fas fa-bars"></i>
                        </button>

                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="javascript:void(0)" @click="isEditName = true">Rename Checklist</a></li>
                            <li><a class="dropdown-item" href="javascript:void(0)" @click="askDelete">Delete Checklist</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else>
                <worksheet-edit-name 
                    v-model="name" 
                    @input="rename"
                    @cancel="isEditName = false"
                ></worksheet-edit-name>
            </div>        
            <h5 class="text-primary">{{ className }} <span v-if="gradingPeriod">({{ gradingPeriod }})</span></h5>
        </div>
        
        <worksheet-date-selector v-model="activeDate" :dates="dates"></worksheet-date-selector>
        <worksheet-date 
            :standards="standards" 
            :students="students"
            :worksheet-date="worksheetDate"
            :worksheet="worksheet"
            @create-worksheet="create"
            @remove="removeDate"
            @create="updateDate"
            @update="updateDate"
        ></worksheet-date>

        <worksheet-print :dates="dates"></worksheet-print>
        <div class="mt-4">
            <home-button></home-button>
            <button class="btn btn-primary" @click="askDelete" :disabled="!worksheet"><i class="fas fa-trash me-2"></i>Delete Checklist</button>
        </div>
    </div>
</template>

<style></style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { DateTime } from "luxon";

import WorksheetEditName from './WorksheetEditName.vue';
import WorksheetDateSelector from './WorksheetDateSelector.vue';
import WorksheetDate from './WorksheetDate.vue';
import WorksheetPrint from './WorksheetPrint.vue';
import ConfirmBox from './ConfirmBox';
import HomeButton from './HomeButton.vue';

export default {
    components: { 
        Loading,
        WorksheetEditName,
        WorksheetDateSelector, 
        WorksheetDate,
        WorksheetPrint, 
        HomeButton,
        ConfirmBox,
    },

    mounted() {
        this.load();
    },

    computed: {
        worksheetDate: {
            get: function() {
                const date = this.dates.find(d => d.evaluation_date == this.activeDate) ?? {};
                return {
                    id: date.id ?? null,
                    evaluation_date: this.activeDate,
                    assessment_opportunity: date.assessment_opportunity ?? '',
                    assessments: date.assessments ?? [],
                    worksheets_id: this.worksheet,
                };
            },

            set: function(value) {
                const idx = this.dates.findIndex(d => d.evaluation_date == this.activeDate);
                if (idx === -1) {
                    this.dates.push(value);
                } else {
                    this.dates[idx] = value;
                }
            }
        },
    },

    methods: {
        rename: function() {
            console.log(this.name);
            if (this.worksheet) {
                this.update();
            } else {
                this.create();
            }
        },

        create: function() {
            this.isEditName = false;
            this.isLoading = true;

            const data = {
                class: parseInt(this.$route.query.class) ?? null,
                standards: this.$route.query.standards ?? null,
                name: this.name,
            };
            
            axios.post('/api/worksheet', data)
                .then(response => {
                    console.log(response.data);
                    this.worksheet = response.data.id ?? null;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });        
        },

        update: function() {
            this.isEditName = false;
            this.isLoading = true;

            if (!this.worksheet) {
                console.warn('NO WORKSHEET');
                return;
            }
            let data = { 
                name: this.name,
            };
            axios
                .patch(`/api/worksheet/${this.worksheet}`, data)
                .then(response => {
                    this.worksheet = response.data.id;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        load: function() {
            let url = '';
            if (this.worksheet = parseInt(this.$route.query.ws) ?? null) {
                url = `/api/worksheet/${this.worksheet}`;
            } else {
                const cl = parseInt(this.$route.query.class) ?? null;
                const st = this.$route.query.standards ?? null;
                console.log('STANDARDS');
                console.log(st[0]);
                url = `/api/worksheet/new?class=${cl}&standards=${st}`;
            }

            this.isLoading = true;
            axios
                .get(url)
                .then(response => {
                    console.log('TEMP WORKSHEET ⇩⇩⇩');
                    console.log(response.data);
                    this.students = response.data.students ?? [];
                    this.standards = response.data.standards ?? [];
                    this.dates = response.data.assessment_dates ?? [];

                    this.worksheet = response.data.id ?? null;
                    this.name = response.data.name ?? '';
                    this.className = response.data.classes.name ?? '';
                    this.gradingPeriod = response.data.classes.grading_period ?? '';
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        askDelete: function() {
            this.$refs.confirm.show({
                title: 'Delete Worksheet',
                content: 'Are you sure you would like to delete this worksheet?',
                callback: () => this.delete(),
            });
        },

        delete: function() {
            if (this.worksheet) {
                this.isLoading = true;
                axios.delete(`/api/worksheet/${this.worksheet}`)
                    .then(result => {
                        console.log('Deleted!');
                    })
                    .catch(err => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.$router.push('/');
                    });
            }
        },

        removeDate: function(event) {
            this.dates = this.dates.filter(d => d.id != event);
        },

        updateDate: function(event) {
            const index = this.dates.findIndex(d => d.id == event.id);
            if (index === -1) {
                this.dates.push(event);
            } else {
                this.dates[index] = event;
            }
        },
    },

    data() {
        return {
            worksheet: null,
            standards: [],
            students: [],
            dates: [],

            className: '',
            gradingPeriod: '',
            name: 'Worksheet',
            tempName: this.name,

            isLoading: false,
            isEditName: false,
            dateEdit: -1,
            activeDate: DateTime.now().startOf('day').toSQLDate(),
        }
    }
}


</script>